// Operations → History. What has already happened, and what it produced.
import React from "react";

import PageHead from "../../components/PageHead";
import Panel, { Rows } from "./Panel";
import { useEndpoint } from "./useEndpoint";

export default function History() {
  const digests = useEndpoint("/digest/history");
  const alerts = useEndpoint("/telegram/alerts/history");

  const digestRows = Array.isArray(digests.data?.digests)
    ? digests.data.digests
    : Array.isArray(digests.data)
    ? digests.data
    : [];
  const alertRows = Array.isArray(alerts.data?.alerts)
    ? alerts.data.alerts
    : Array.isArray(alerts.data)
    ? alerts.data
    : [];

  return (
    <>
      <PageHead
        title="History"
        subtitle="What has already happened, and what it produced."
      />

      <div className="grid op-grid">
        <Panel
          title="Digests"
          state={digests}
          empty={digestRows.length === 0}
          note="/api/digest/history holds no digests yet."
        >
          <Rows
            items={digestRows.slice(0, 20).map((d, i) => [
              String(d?.generated_at ?? d?.created_at ?? `digest ${i + 1}`),
              String(d?.title ?? d?.summary ?? "—").slice(0, 80),
            ])}
          />
        </Panel>

        <Panel
          title="Alerts sent"
          state={alerts}
          empty={alertRows.length === 0}
          note="/api/telegram/alerts/history holds no alerts yet."
        >
          <Rows
            items={alertRows.slice(0, 20).map((a, i) => [
              String(a?.sent_at ?? a?.created_at ?? `alert ${i + 1}`),
              String(a?.kind ?? a?.type ?? a?.offer_id ?? "—"),
            ])}
          />
        </Panel>
      </div>
    </>
  );
}
